import React from "react"
import Layout from "../components/Layouts/platformLayout"
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "../components/header"
import { graphql } from "gatsby"

export default ({ data }) => (
  <>
    <Header />
    <Layout data={data.enJson.platform}/>
  </>
)

export const query = graphql`
  query {
    enJson {
      platform {
        li1
        li10
        li11
        li12
        li13
        li14
        li15
        li16
        li2
        li3
        li4
        li5
        li6
        li7
        li8
        li9_1
        li9_2
        title
      }
    }
  }
`
